<template>
  <list-items-loadable
    v-slot="{ item }"
    :items="items"
    empty-text="Нет оглавления документа."
    cssClass="document-sidebar__contents"
  >
    <div
      v-if="hasScan || hasHtml"
      class="div_as_a"
      :style="makeItemLinkStyle(item)"
      @click="handleListItemClick(item)"
    >
      {{ item.title }}
    </div>
  </list-items-loadable>
</template>

<script>
import { mapGetters } from 'vuex';

import ListItemsLoadable from '@@/shared/list/ListItemsLoadable';

export default {
  components: {
    ListItemsLoadable
  },

  props: {
    currentView: {
      type: String,
      required: true,
      default: () => 'card'
    },
    hasScan: {
      type: Boolean,
      default: () => false
    },
    hasHtml: {
      type: Boolean,
      default: () => false
    }
  },

  computed: {
    ...mapGetters({
      itemsScanContent: 'currentDocumentScanContent',
      itemsTextContent: 'currentDocumentTextContent',
      documentId: 'currentDocumentId'
    }),
    contentView() {
      let contentView = this.hasScan ? 'scan' : this.hasHtml ? 'html' : 'card';

      if (this.currentView === 'html' || this.currentView === 'scan') {
        contentView = this.currentView;
      }

      return contentView;
    },
    items() {
      switch (this.contentView) {
        case 'html':
          return this.itemsTextContent;
        case 'scan':
          return this.itemsScanContent;
        default:
          return [];
      }
    }
  },

  methods: {
    handleListItemClick(item) { // eslint-disable-line
      let hash = '';

      if (this.contentView === 'html' && item.anchorId)
        hash = `#${item.anchorId}`;
      if (this.contentView === 'scan' && item.pageNumber)
        hash = `#${item.pageNumber}`;

      // Это нужно для того, чтобы произвести фактические изменения в интерфейсе приложения
      this.$emit('content-item-clicked', {
        view: this.contentView,
        hash: hash
      });
      // Это нужно для формирования истории просмотра и возможности обмена ссылками
      this.$router.push({
        name: 'document',
        params: {
          id: this.documentId,
          view: this.contentView
        },
        hash: hash
      });
    },
    makeItemLinkStyle(item) {
      return { marginLeft: `${item.level}em` };
    }
  }
};
</script>
